import { render, staticRenderFns } from "./CallPad.vue?vue&type=template&id=4ca4d97a"
import script from "./CallPad.vue?vue&type=script&lang=js"
export * from "./CallPad.vue?vue&type=script&lang=js"
import style0 from "./CallPad.vue?vue&type=style&index=0&id=4ca4d97a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports